import React, { useState } from 'react'
import SbEditable from 'storyblok-react'
import Slider from "react-slick";
import OpenQuotation from "src/images/open_quotation.svg";
import GetTestimonials from "src/utils/GetTestimonials"
import RichText from "src/utils/RichText"
import FluidImage from "src/utils/FluidImage"

const TestimonialSideBySide = ({ blok }) => {
    
    const [currentIndex, setCurrentIndex] = useState(0);
    
    const settings = {
        className: 'testimonial-side-by-side',
        dots: false,
        fade: false,
        arrows: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 8000,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                dotsClass: `slick-dots lg:!block !-bottom-8 !mt-10`,
                beforeChange: (current, next) => setCurrentIndex(next),
                appendDots: dots => (
                    <div>
                    <ul className="">
                        {dots.map((item, index) => (
                            <li className="!m-[2px] !h-[8px] !w-[8px]" key={index}>
                            {item.props.children}
                            </li>
                        ))}
                    </ul>
                </div>
                ),
                customPaging: i => (
                    <div
                        className={`relative w-full h-full transition-colors rounded-full duration-300 ${
                        i === currentIndex ? "bg-blue" : "bg-darkblue-200"
                        }`}
                    ></div>
                ),
              }
            },
        ]
    };

    return (
        <SbEditable content={blok} key={blok._uid}>
            <section className="bg-lightgrey pt-4 md:pt-14 xl:pb-14 pb-20">
                <div className="max-w-7xl mx-auto px-8 md:px-6 lg:px-8 2xl:max-w-screen-2xl">
                    <Slider {...settings}>
                        {GetTestimonials(blok.testimonials).map((testimonial, index) => (
                                <div className="flex align-center h-full">
                                    <div className={`m-auto py-12 px-4 sm:px-6 md:py-16 h-full ${index % 2 === 0 ? 'md:border-r md:pr-10 lg:pr-20': 'md:pl-10 lg:pl-20'} 'md:border-purple-50 border-opacity-30`}>
                                        <div className="mt-6 flex-grow flex flex-col h-full lg:gap-12 gap-8 md:justify-between">
                                            <div className="relative text-lg font-medium text-white md:flex-grow">
                                                <OpenQuotation className="absolute fill-purple opacity-[0.15] top-0 left-0 transform -translate-x-3 -translate-y-6 h-12 w-12" fill="currentColor" viewBox="0 0 32 32" aria-hidden="true" />
                                                <div className="relative text-blue prose lg:text-lg text-base tracking-[-0.01em]">
                                                    <RichText>{testimonial.content.content}</RichText>
                                                </div>
                                            </div>
                                            <div className="flex flex-row flex-nowrap items-start h-[65px] md:justify-start gap-4">
                                                <div>
                                                    <FluidImage image={testimonial.content.image} className="h-12 w-12 rounded-full object-cover"/>
                                                </div>
                                                <div>
                                                    <h4 className="lg:text-base text-sm font-bold text-blue">{testimonial.name}</h4>
                                                    <p className="lg:text-base text-sm !leading-5 font-medium text-purple opacity-30">{testimonial.content.job_title}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </Slider>  
                </div>                       
            </section>
        </SbEditable>
    )
}

export default TestimonialSideBySide